import { SxProps, Theme } from '@mui/material';

export const styles: Record<string, SxProps<Theme>> = {
  container: (theme: Theme) => ({
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: theme.spacing(1),
    padding: theme.spacing(4),
    backgroundColor: theme.palette.common.white,
    borderRadius: theme.spacing(2),
    [theme.breakpoints.down('sm')]: {
      padding: theme.spacing(2),
      gap: theme.spacing(0.5),
    },
  }),

  fieldsWrapper: (theme: Theme) => ({
    width: '100%',
    mt: theme.spacing(2),
    [theme.breakpoints.down('sm')]: {
      mt: theme.spacing(1),
    },
  }),

  fieldsWrapperItem: () => ({
    minWidth: 0,
    width: '100%',
  }),

  purposeText: (theme: Theme) => ({
    fontSize: '15px',
    color: theme.palette.text.primary,
    [theme.breakpoints.down('sm')]: {
      fontSize: '13px',
    },
  }),

  checkboxWrapper: (theme: Theme) => ({
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    gap: theme.spacing(1),
    [theme.breakpoints.down('sm')]: {
      gap: theme.spacing(0.75),
    },
  }),

  checkboxLabel: (theme: Theme) => ({
    width: 'fit-content',
    alignItems: 'flex-start',
    [theme.breakpoints.down('sm')]: {
      '& .MuiFormControlLabel-label': {
        fontSize: '14px',
      },
    },
  }),

  conditionalField: (theme: Theme) => ({
    width: '50%',
    [theme.breakpoints.down('sm')]: {
      width: '100%',
    },
  }),

  errorText: (theme: Theme) => ({
    position: 'relative',
    [theme.breakpoints.down('sm')]: {
      fontSize: '12px',
    },
  }),

  phoneFieldWrapper: (theme: Theme) => ({
    width: '100%',
    '& .MuiFormControl-root > .MuiInputLabel-root': {
      lineHeight: 1.2,
    },
    '& .MuiFormControl-root > .MuiBox-root': {
      marginTop: 0,
    },
    '& .MuiFormControl-root > .MuiFormHelperText-root': {
      marginTop: theme.spacing(1),
    },
  }),
};
